/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ModelMetadataBooleanFunc from './ModelMetadataBooleanFunc';

/**
 * The IPropertyFilterProvider model module.
 * @module model/IPropertyFilterProvider
 * @version V1
 */
class IPropertyFilterProvider {
    /**
     * Constructs a new <code>IPropertyFilterProvider</code>.
     * @alias module:model/IPropertyFilterProvider
     */
    constructor() { 
        
        IPropertyFilterProvider.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>IPropertyFilterProvider</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/IPropertyFilterProvider} obj Optional instance to populate.
     * @return {module:model/IPropertyFilterProvider} The populated <code>IPropertyFilterProvider</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new IPropertyFilterProvider();

            if (data.hasOwnProperty('propertyFilter')) {
                obj['propertyFilter'] = ModelMetadataBooleanFunc.constructFromObject(data['propertyFilter']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>IPropertyFilterProvider</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>IPropertyFilterProvider</code>.
     */
    static validateJSON(data) {
        // validate the optional field `propertyFilter`
        if (data['propertyFilter']) { // data not null
          ModelMetadataBooleanFunc.validateJSON(data['propertyFilter']);
        }

        return true;
    }


}



/**
 * @member {module:model/ModelMetadataBooleanFunc} propertyFilter
 */
IPropertyFilterProvider.prototype['propertyFilter'] = undefined;






export default IPropertyFilterProvider;

